import { render } from "./TelephoneInputComponent.vue?vue&type=template&id=e3c879d4&scoped=true"
import script from "./TelephoneInputComponent.vue?vue&type=script&lang=js"
export * from "./TelephoneInputComponent.vue?vue&type=script&lang=js"

import "./TelephoneInputComponent.vue?vue&type=style&index=0&id=e3c879d4&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c879d4"]])

export default __exports__